import request from "@/utils/request";

export const getFinancialConfiguration = () =>
  request({
    url: "/configuration/financial",
    method: "GET"
  });

export const updateFinancialConfiguration = (exchangeRateUSD: string, merUSD: string,
                                             exchangeRateEURO: string, merEURO: string,
                                             exchangeRateRMB: string, merRMB: string) =>
  request({
    url: "/configuration/financial",
    method: "PUT",
    data: { exchangeRateUSD, merUSD, exchangeRateEURO, merEURO, exchangeRateRMB, merRMB }
  });





